import api from '@/modules/attendance/api'

const sidebarStore = {
  namespaced: true,
  state: () => ({
    patient: null
  }),
  mutations: {
    setPatient(state, payload) {
      state.patient = payload
    },
    addPatientSummaryItem(state, payload) {
      state.patient.patient_summaries.push(payload)
    },
    removePatientSummaryItem(state, payload) {
      state.patient.patient_summaries = state.patient.patient_summaries.filter(
        item => item.id !== payload
      )
    }
  },
  getters: {
    getPatient: state => {
      return state.patient
    }
  },
  actions: {
    async setPatient(context, payload) {
      try {
        const response = await api.getCompletePatient(payload)
        context.commit('setPatient', response.data)
      } catch (error) {
        console.log(error)
      }
    },
    addPatientSummaryItem(context, payload) {
      context.commit('addPatientSummaryItem', payload)
    },
    removePatientSummaryItem(context, payload) {
      context.commit('removePatientSummaryItem', payload)
    }
  }
}

export default sidebarStore
